import { createFeatureSelector, createSelector } from '@ngrx/store';
import type { PasswordRecoverStatus } from './password.state';
import type { AuthState } from '../auth.state';

const selectAuthState = createFeatureSelector<AuthState>('auth');
const selectPasswordState = createSelector(selectAuthState, state => state.password);

export interface RecoverPasswordState {
  status: PasswordRecoverStatus;
  email: string;
}

export const selectRecoverPasswordState = createSelector(selectPasswordState, (state): RecoverPasswordState => {
  return {
    status: state.recoverStatus,
    email: state.recoverEmail
  };
});

const selectResetPasswordState = createSelector(selectPasswordState, state => state.reset);

export const selectResetPasswordStatus = createSelector(selectResetPasswordState, state => state.status);
